export const GET_QUIZ_QUESTION_REQUEST = 'GET_QUIZ_QUESTION_REQUEST'
export const GET_QUIZ_QUESTION_SUCCESS = 'GET_QUIZ_QUESTION_SUCCESS'
export const GET_QUIZ_QUESTION_FAILED = 'GET_QUIZ_QUESTION_FAILED'